<app-popup-info />
<app-popup-confirm />
<router-outlet />
